import { render, staticRenderFns } from "./SubCategoria.vue?vue&type=template&id=09e654e9&scoped=true&"
import script from "./SubCategoria.vue?vue&type=script&lang=js&"
export * from "./SubCategoria.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoria.vue?vue&type=style&index=0&id=09e654e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e654e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
